import CharCreate from "./charcreate";
import {s_char, s_char_notes} from "../_signals/s_char";
import {v4} from "uuid";
import updChar from "../_sig_api/updChar";
import {getBaseCharUpd} from "../_signals/s_char_calc";
import {ICharMod} from "../_interfaces/ICharMod";
import {ModsAdd} from "../_api/BEMods";
import {TalentsAdd} from "../_api/BETalents";
import {NotesCreate} from "../_api/BENotes";
import {ICharNote} from "../_interfaces/ICharNote";
import {s_app_cid, s_app_rid} from "../_signals/s_app";
import {date2Timestamp} from "./dates";

function cc_done() {
    const race = s_char.value.race;

    const CharRace = CharCreate.races[race];

    const now = new Date()
    const newnote: ICharNote = {id: v4(), cid: s_char.value.id, ts: date2Timestamp(now), entry: race + ' ' + CharRace.bonus}
    s_char_notes.value = [...s_char_notes.value, newnote];


    NotesCreate(newnote);

    let modAdd: ICharMod[] = [];
    if (race === 'mensch') {
        TalentsAdd([{
            id: v4(),
            cid: s_app_cid.value,
            name: "Vielseitigkeit",
            attribute: "none",
            action: "none",
            strain: 0,
            discipline: "Mensch",
            lpstart: 100,
            circle: 0,
            descr: "",
            optional: false,
            karma: false,
            free: false,
            step: 0,
            stepfree: 0,
            define: []
        }]);
    }

    if (race === 'windling') {
        modAdd.push({
            id: v4(),
            cid: s_app_cid.value,
            mfrom: 'Windling',
            what: 'kv',
            mmod: 2,
            type: 'constant',
            disabled: true,
            msource: 'race_mod',
            msourceid: '',
            strain: 0,
            duration: 0,
            sl: false
        });
    }

    if (race === 'obsidianer') {
        modAdd.push({
            id: v4(),
            cid: s_app_cid.value,
            msource: 'race_mod',
            msourceid: '',
            mfrom: 'Obsidianer',
            what: 'wund',
            mmod: 3,
            type: 'constant',
            disabled: true,
            strain: 0,
            duration: 0,
            sl: false
        })
        modAdd.push({
            id: v4(),
            cid: s_app_cid.value,
            mfrom: 'Obsidianer',
            what: 'pr',
            mmod: 3,
            type: 'constant',
            disabled: true,
            msource: 'race_mod',
            msourceid: '',
            strain: 0,
            duration: 0,
            sl: false
        });
    }

    ModsAdd(s_char.value.id, s_app_rid.value, modAdd);

    let charUpd = getBaseCharUpd();
    charUpd.push({k: 'cc_attr', v: true})

    updChar(charUpd)
}

export default cc_done